import React from "react";
import ModeEditOutlineOutlinedIcon from "@mui/icons-material/ModeEditOutlineOutlined";
import CheckOutlinedIcon from "@mui/icons-material/CheckOutlined";
import styled from "styled-components";
import { Button } from "components";

const ButtonsWrapper = styled.div`
    display: flex;
    align-items: center;
`;
function EditHandler({ isOnEdit, setIsOnEdit }) {
    const handleConfirmeEidt = () => {
        setIsOnEdit(false);
    };

    return (
        <div>
            {!isOnEdit && (
                <Button
                    type="button"
                    onChange={() => setIsOnEdit(true)}
                    icon={<ModeEditOutlineOutlinedIcon />}
                />
            )}
            {isOnEdit && (
                <ButtonsWrapper>
                    <Button
                        type="button"
                        icon={<CheckOutlinedIcon />}
                        onChange={() => handleConfirmeEidt()}
                    />
                </ButtonsWrapper>
            )}
        </div>
    );
}

export default EditHandler;
